'use strict';
//import "intl";
//import "intl-messageformat";

import angular from "angular";
import moment from "./moment";
import lodash from "./lodash.js";
import ConfigService from "./ConfigService";
import LocaleService from "./LocaleService";
import Events from "./Events";


class SyscodeService {

    constructor($locale, $window, $rootScope, Events, ConfigService, $http, $q, _, $state, moment, LocaleService) {
        this.LocaleService = LocaleService;
        this.syscodePrefix  = "dot\\.syscodes";
    }

    getSyscodes(syscodeGroup) {
        var syscodeTranslations = this.LocaleService.getListByRegexp(this.syscodePrefix + "\\." + syscodeGroup + "\\.");
        return Object.keys(syscodeTranslations).map((elem) => elem.split(".").pop());
    }

}

SyscodeService.$inject = ["$locale", "$window", "$rootScope", "Events", "ConfigService", "$http", "$q", "_", "$state", "moment", "LocaleService"];

export default angular.module("services.SyscodeService", [ConfigService, moment, Events, ConfigService, LocaleService, lodash])
    .service("SyscodeService", SyscodeService)
    .name;


// WEBPACK FOOTER //
// ./src/ui/app/services/SyscodeService.js